export const mapToDefault = <T>(value: T | null | undefined, defaultValue: T): T => value ?? defaultValue
